module.exports = __webpack_public_path__ + "static/media/tenderbanner.daae045b.png";